import { useQuery } from '@tanstack/react-query';

import { api } from '../config/api';

/**
 * GET /carousel/cover-lines → the curated cover-line headlines.
 *
 * The list rarely changes, so it's cached for an hour.
 */
export function useCoverLines() {
  return useQuery({
    queryKey: ['cover-lines'],
    queryFn: () => api<{ coverLines: string[] }>('/carousel/cover-lines'),
    staleTime: 60 * 60 * 1000,
  });
}
